import { SessionData } from "./auth.interfaces";

/**
 * Default iFirm login timeout, in minutes. Only used when the parent's payload
 * omits `sessionExpiration`; the parent's own value always wins.
 */
export const DEFAULT_SESSION_TIMEOUT_MINUTES = 20;

/**
 * Single conversion point between the parent's raw iframe payload and {@link SessionData}.
 *
 * The parent sends `sessionExpiration` as a DURATION IN MINUTES; `SessionData.sessionExpiration`
 * is an ABSOLUTE epoch-ms deadline. This unit has changed three times historically (seconds ->
 * minutes-from-parent -> absolute epoch ms), and the old @ng-idle code fed the raw value straight
 * into interval arithmetic. Both `initSession` and `updateSession` responses go through here so
 * that conversion exists in exactly one place.
 */
export function toSessionData(payload: Record<string, unknown>, timeoutMinutesFallback = DEFAULT_SESSION_TIMEOUT_MINUTES): SessionData {
    const minutes = typeof payload.sessionExpiration === "number" ? payload.sessionExpiration : timeoutMinutesFallback;
    return {
        site: payload.site as string,
        sessionName: payload.sessionName as string,
        userId: payload.userId as string,
        sessionExpiration: Date.now() + minutes * 60 * 1000,
    };
}
